import {
  db,
  collection,
  getDocs,
  query,
  orderBy,
  addDoc,
  doc,
  deleteDoc,
  storage,
  ref,
  uploadBytes,
  getDownloadURL,
  deleteObject
} from './firebase';

export interface Report {
  id: string;
  title: string;
  description: string;
  file_url: string;
  file_name: string;
  created_at: string;
  date: string;
}

export const uploadReportPdf = async (file: File): Promise<string> => {
  const fileRef = ref(storage, `reports/${Date.now()}_${file.name}`);
  await uploadBytes(fileRef, file);
  return await getDownloadURL(fileRef);
};

export const fetchAllReports = async (): Promise<Report[]> => {
  try {
    const q = query(collection(db, "reports"), orderBy("created_at", "desc"));
    const snapshot = await getDocs(q);
    return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() } as Report));
  } catch (e) {
    console.error("Firestore error in fetchAllReports", e);
    return [];
  }
};

export const createReport = async (reportData: Omit<Report, 'id' | 'date' | 'created_at'>) => {
  const docRef = await addDoc(collection(db, "reports"), {
    ...reportData,
    date: new Date().toLocaleDateString('fr-FR', { day: '2-digit', month: 'short', year: 'numeric' }),
    created_at: new Date().toISOString()
  });
  return docRef.id;
};

export const deleteReport = async (reportId: string, fileUrl: string) => {
  try {
    // Delete document from Firestore
    await deleteDoc(doc(db, "reports", reportId));
    
    // Attempt to delete file from Storage if it's hosted on our Firebase Storage
    if (fileUrl && fileUrl.includes('firebasestorage')) {
      const fileRef = ref(storage, fileUrl);
      try {
        await deleteObject(fileRef);
      } catch (storageError) {
        console.warn("Could not delete file from storage, it might have been already deleted.", storageError);
      }
    }
  } catch (error) {
    console.error("Error deleting report: ", error);
    throw error;
  }
};
